import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { AdverticalService } from 'src/app/services/adverticalService/advertical.service';
import { AssetsService } from 'src/app/services/assetsService/assets.service';
import { BookmarkService } from 'src/app/services/bookmarkService/bookmark-service.service';
import { ListService } from 'src/app/services/listService/list-service.service';
import { UserService } from 'src/app/services/userService/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {
  changeLanguageListener;
  features = environment.features;
  ribbons;
  banners;
  public bannerConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    loop: true,
    autoplay: true,
    slidesPerView: 1,
    spaceBetween: 0,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: true,
    slidesOffsetBefore: 0
  };
  constructor(private router: Router, private assetsService: AssetsService, private userService: UserService, private bookmarkService: BookmarkService, private listService: ListService, private adverticalService: AdverticalService) { }

  ngOnInit(): void {
    this.getData();

    // Update home when the user change profile language via edit profile
    this.changeLanguageListener = this.userService.onChangeLanguage.subscribe(resp => {
      this.getData();
    });
  }

  getData() {
    this.assetsService.getHome().then((resp: any) => {
      this.getPersonalizedContent().then((persoResp: any) => {

        let ribbons = new Array();
        this.banners = resp?.data?.ribbons.find(obj => obj.style == "A" && obj.type == "Banner");

        // Change Banners Config based on how many banners we have
        if (this.banners?.assets?.length <= 1) {
          this.bannerConfig.autoplay = false;
          this.bannerConfig.pagination = false;
        }

        resp.data.ribbons.forEach(obj => {
          switch (obj.type) {
            case "Assets":
              ribbons.push(obj);
              break;
            case "Bookmarks":
              if (persoResp && persoResp.bookmarks) {
                ribbons.push({ title: "gen_bookmarks", assets: persoResp.bookmarks, style: obj.style });
              }
              break;
            case "MyList":
              if (persoResp && persoResp.myList) {
                ribbons.push({ title: "gen_my_list", assets: persoResp.myList, style: obj.style });
              }
              break;
          }
        });

        // Custom Home Logic for DISFF
        if (this.features.customHome) {
          this.getRibbons().then((resp2: any) => {
            this.ribbons = resp2.ribbons.concat(ribbons);
          });
        } else {
          this.ribbons = ribbons;
        }
        this.adverticalService.getBanner("Home_Banner", "HOME_BANNER", false);
        this.adverticalService.getBanner("Home_Banner_Bottom", "HOME_BANNER_BOTTOM", false);

      });
    });
  }

  // Get Bookmarks and My List Personalized Content
  getPersonalizedContent() {
    if (!this.userService.getUser().isGuest) {
      return new Promise(resolve => {
        this.bookmarkService.getBookmarks({}).then((bookmarks: any) => {
          this.listService.getList({}).then((mylist: any) => {
            resolve({ bookmarks: bookmarks.data.bookmarks, myList: mylist.data.myList })
          });
        });
      });
    } else {
      return new Promise(resolve => { resolve(null) })
    }
  }

  // Get catalog ribbons
  getRibbons() {
    return this.assetsService.getCatalogRibbons({ categoryId: this.features.customHomeVal });
  }

  // Destroy subscriptions to avoid memory leaks
  ngOnDestroy(): void {
    if (this.changeLanguageListener) {
      this.changeLanguageListener.unsubscribe();
    }
  }
}